import { useEffect } from "react";

const usePointsOfInterestLayer = (map, pointsofinterest_active) => {
  useEffect(() => {
    if (!map) return;

    const activePOIs = pointsofinterest_active || [];

    // Load UNESCO icon if not already loaded
    if (!map.hasImage("unesco-icon")) {
      map.loadImage("/assets/unesco.png", (error, image) => {
        if (error) throw error;
        if (!map.hasImage("unesco-icon")) {
          map.addImage("unesco-icon", image, {
            pixelRatio: 2, // Since 192px image should display at 48px (192/48 = 4)
            sdf: false,
          });
        }
      });
    }

    // Get all existing POI layers
    const existingPOILayers =
      map
        .getStyle()
        ?.layers?.filter((layer) => layer.id.endsWith("-poi-layer"))
        .map((layer) => layer.id.replace("-poi-layer", "")) || [];

    // Remove layers that are no longer active
    existingPOILayers.forEach((poiType) => {
      if (!activePOIs.includes(poiType)) {
        const layerName = `${poiType}-poi-layer`;
        const sourceName = `${poiType}-poi`;

        // Remove layer and source
        if (map.getLayer(layerName)) {
          map.removeLayer(layerName);
        }
        if (map.getSource(sourceName)) {
          map.removeSource(sourceName);
        }
      }
    });

    // Add layers for active POIs
    activePOIs.forEach((poiType) => {
      const sourceName = `${poiType}-poi`;
      const layerName = `${poiType}-poi-layer`;

      if (!map.getLayer(layerName)) {
        // Add source if it doesn't exist
        if (!map.getSource(sourceName)) {
          map.addSource(sourceName, {
            type: "geojson",
            data: `/data/${poiType}.geojson`,
          });
        }

        // Add layer
        map.addLayer(
          {
            id: layerName,
            type: "symbol",
            source: sourceName,
            layout: {
              "icon-image": "unesco-icon",
              "icon-size": 0.5,
              "icon-allow-overlap": true,
            },
            paint: {
              "icon-halo-color": "#ffffff",
              "icon-halo-width": 2,
            },
          },
          "poi-label"
        );
      }
    });
  }, [map, pointsofinterest_active]);
};

export default usePointsOfInterestLayer;
